/* os_plan.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="4.88 2.7 17.6 17.5" preserveAspectRatio="none">
            <path class="foreground-gl" d="M356.24,2.74A8.83,8.83,0,1,0,365,11.56,8.8,8.8,0,0,0,356.24,2.74Zm5.24,10.72-4.9,5.32-4.9-5.32h2.94V10.3h-2.94l4.9-5.89,4.9,5.89h-2.93v3.16Z" transform="translate(-342.47 -0.09)"/>
        </svg>
    `
};
